// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"604dd7ba","426":"bc4a9666","766":"ecdbc013","789":"e2a3d3b5"}[chunkId] + ".chunk.css";
};